/* ==========================================================================
   REVENDEX — Tema Shopify · Interacciones
   Drawers · Buscador predictivo · Carrito AJAX · Acordeones · Reveal · Carruseles
   Delegación de eventos global para sobrevivir a re-renderizados de secciones.
   ========================================================================== */
(function () {
  'use strict';

  var S = window.REVENDEX || {};
  var routes = S.routes || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ------------------------------------------------------------------
     Header: estado al hacer scroll
  ------------------------------------------------------------------ */
  function initHeaderState() {
    var header = $('[data-section-root="header"]');
    if (!header) return;
    /* Sin este guard, cada re-render donde el header NO cambia de nodo
       (p. ej. editar otra sección en el editor de temas) añadiría un
       listener de scroll duplicado sobre el mismo elemento. */
    if (header.dataset.stateBound === '1') return;
    header.dataset.stateBound = '1';
    var update = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 4);
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ------------------------------------------------------------------
     Drawers y modales
  ------------------------------------------------------------------ */
  var lastFocused = null;

  function getOverlay() { return $('[data-overlay]'); }

  function openPanel(name) {
    var panel = $('[data-panel="' + name + '"]');
    if (!panel) return;
    lastFocused = document.activeElement;
    var wasOpen = panel.classList.contains('is-open');
    closeAllPanels(true);
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    /* Animación slide-left del carrito: solo al pasar de cerrado a abierto
       (así no se repite al refrescar el carrito en caliente). */
    if (!wasOpen && panel.classList.contains('drawer--right')) {
      panel.classList.add('slide-left');
    }
    var overlay = getOverlay();
    if (overlay) {
      /* Carrera del overlay: si se cierra y reabre rápido, el timer que
         esconde el overlay debe cancelarse o este desaparece con el panel abierto. */
      if (overlay._hideTimer) clearTimeout(overlay._hideTimer);
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    }
    document.documentElement.classList.add('lock-scroll');
    var focusable = panel.querySelector('input:not([type="hidden"]), button, a[href], select, textarea');
    if (focusable) setTimeout(function () { focusable.focus(); }, 120);
    document.dispatchEvent(new CustomEvent('revendex:panel:open', { detail: { name: name } }));
  }

  function closePanel(name) {
    var panel = name ? $('[data-panel="' + name + '"]') : $('[data-panel].is-open');
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.classList.remove('slide-left');
    panel.setAttribute('aria-hidden', 'true');
    var overlay = getOverlay();
    if (overlay) {
      overlay.classList.remove('is-open');
      if (overlay._hideTimer) clearTimeout(overlay._hideTimer);
      /* 1050ms = fade del overlay (1s) + margen. Con pointer-events: none
         en el estado cerrado, el overlay ya NO bloquea clics mientras se desvanece. */
      overlay._hideTimer = setTimeout(function () { overlay.hidden = true; }, 1050);
    }
    document.documentElement.classList.remove('lock-scroll');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function closeAllPanels(skipOverlay) {
    $$('[data-panel].is-open').forEach(function (p) {
      p.classList.remove('is-open');
      p.classList.remove('slide-left');
      p.setAttribute('aria-hidden', 'true');
    });
    document.documentElement.classList.remove('lock-scroll');
    if (!skipOverlay) {
      var overlay = getOverlay();
      if (overlay) {
        overlay.classList.remove('is-open');
        if (overlay._hideTimer) clearTimeout(overlay._hideTimer);
        overlay._hideTimer = setTimeout(function () { overlay.hidden = true; }, 1050);
      }
    }
  }

  function initPanels() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-open-panel]');
      if (opener) {
        e.preventDefault();
        openPanel(opener.getAttribute('data-open-panel'));
        return;
      }
      if (e.target.closest('[data-close-panel]')) {
        e.preventDefault();
        closePanel();
        return;
      }
      var overlay = e.target.closest('[data-overlay]');
      if (overlay) { closePanel(); return; }
      /* Clic en el fondo oscuro del buscador también cierra */
      if (e.target.classList && e.target.classList.contains('search-modal')) { closePanel(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });
    /* Al terminar slide-left se retira la clase: el estado .is-open mantiene
       la misma posición (translateX(-100px)) y así no se repite al refrescarse
       la sección del carrito. */
    document.addEventListener('animationend', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('slide-left')) {
        t.classList.remove('slide-left');
      }
      if (t && t.classList && t.classList.contains('slide-bottom')) {
        /* La entrada del buscador es de un solo uso: no re-animar si el nodo
           se clona/re-inserta (p. ej. al refrescar secciones). */
        t.dataset.entered = '1';
      }
    });
  }

  /* ------------------------------------------------------------------
     Buscador predictivo
  ------------------------------------------------------------------ */
  var searchAbort = null;
  var searchTimer = null;

  function renderSearchStatus(msgKey) {
    var results = $('[data-predictive-results]');
    if (!results) return;
    results.innerHTML = '<div class="search-status">' + (msgKey || '') + '</div>';
  }

  function runPredictiveSearch(query) {
    var results = $('[data-predictive-results]');
    if (!results) return;
    if (!query || query.trim().length < 2) {
      if (searchAbort) searchAbort.abort();
      results.innerHTML = '';
      return;
    }
    if (searchAbort) searchAbort.abort();
    searchAbort = new AbortController();
    renderSearchStatus((S.strings && S.strings.searching) || '…');
    var url =
      routes.predictiveSearch +
      '?q=' + encodeURIComponent(query.trim()) +
      '&section_id=predictive-search' +
      '&resources[type]=product' +
      '&resources[limit]=6' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,tag,vendor';
    fetch(url, { signal: searchAbort.signal })
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var parsed = new DOMParser().parseFromString(text, 'text/html');
        var fresh = parsed.querySelector('[data-section-root="predictive-search"]');
        results.innerHTML = fresh ? fresh.innerHTML : '';
        var first = results.querySelector('a');
        if (first) first.focus();
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        results.innerHTML = '';
      });
  }

  function initPredictiveSearch() {
    document.addEventListener('input', function (e) {
      var input = e.target.closest('[data-predictive-input]');
      if (!input) return;
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        runPredictiveSearch(input.value);
      }, 260);
    });
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-search-form]');
      if (!form) return;
      var input = form.querySelector('[data-predictive-input]');
      if (input && (!input.value || input.value.trim().length < 2)) {
        e.preventDefault();
        input.focus();
      }
    });
  }

  /* ------------------------------------------------------------------
     Carrito — Section Rendering API
  ------------------------------------------------------------------ */
  function swapSection(id, html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('[data-section-root="' + id + '"]');
    var current = document.querySelector('[data-section-root="' + id + '"]');
    if (fresh && current) {
      /* Preservar el estado de apertura al refrescar en caliente
         (antes: cambiar cantidades cerraba el drawer solo). */
      if (current.classList.contains('is-open')) {
        fresh.classList.add('is-open');
        fresh.setAttribute('aria-hidden', 'false');
      }
      /* La entrada slide-bottom del botón de búsqueda es solo de carga de
         página: si el header se refresca (añadir al carrito), no re-animar. */
      $$('.search-entrance', fresh).forEach(function (se) {
        se.classList.remove('slide-bottom');
      });
      current.replaceWith(fresh);
      return true;
    }
    return false;
  }

  function refreshCart() {
    var requests = [
      fetch((routes.root || '/') + '?sections=cart-drawer,header').then(function (r) { return r.json(); })
    ];
    if (document.querySelector('[data-cart-page]')) {
      requests.push(fetch(routes.cart + '?sections=main').then(function (r) { return r.json(); }));
    }
    return Promise.all(requests).then(function (datasets) {
      datasets.forEach(function (data) {
        Object.keys(data).forEach(function (id) {
          if (id === 'main' && !document.querySelector('[data-cart-page]')) return;
          swapSection(id, data[id]);
        });
      });
      initHeaderState();
    }).catch(function () { /* silencioso */ });
  }

  function changeCart(line, quantity) {
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart');
        return refreshCart();
      })
      .catch(function () {
        alert(S.strings && S.strings.error ? S.strings.error : 'Error');
      });
  }

  function initCart() {
    /* Añadir al carrito (AJAX) */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form || form.querySelector('[name="checkout"]')) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) {
        btn.classList.add('btn--disabled');
        btn.disabled = true;
      }
      fetch(routes.cartAdd + '.js', { method: 'POST', body: new FormData(form) })
        .then(function (res) {
          if (!res.ok) throw new Error('add');
          return refreshCart();
        })
        .then(function () {
          if (S.cartType === 'page') {
            window.location.href = routes.cart;
            return;
          }
          openPanel('cart');
        })
        .catch(function () {
          if (btn) {
            btn.classList.remove('btn--disabled');
            btn.disabled = false;
            btn.innerHTML = original;
          }
        });
    });

    /* Steppers de cantidad */
    document.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty] button');
      if (!step) return;
      var qty = step.closest('[data-qty]');
      var input = qty.querySelector('input');
      if (!input) return;
      var value = parseInt(input.value, 10) || 1;
      value = step.hasAttribute('data-qty-minus') ? value - 1 : value + 1;
      value = Math.max(1, value);
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    /* Cambios de cantidad en carrito */
    document.addEventListener('change', function (e) {
      var input = e.target.closest('input[data-line]');
      if (!input) return;
      var line = parseInt(input.getAttribute('data-line'), 10);
      var quantity = Math.max(0, parseInt(input.value, 10) || 0);
      changeCart(line, quantity);
    });

    /* Eliminar línea */
    document.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-cart-remove]');
      if (!remove) return;
      e.preventDefault();
      var line = parseInt(remove.getAttribute('data-cart-remove'), 10);
      changeCart(line, 0);
    });
  }

  /* ------------------------------------------------------------------
     Acordeones (FAQ)
  ------------------------------------------------------------------ */
  function initAccordions() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.accordion__btn');
      if (!btn) return;
      var item = btn.closest('.accordion__item');
      if (!item) return;
      var isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  /* ------------------------------------------------------------------
     Reveal al hacer scroll
     — revealAuto: marca cabeceras/FAQs/reseñas con stagger.
     — revealScan: observa los .reveal aún no visibles de un scope.
     Separado en funciones con scope para poder re-vincular UNA sección
     concreta cuando el editor de temas la re-renderiza
     (shopify:section:load): los nodos nuevos no están observados y
     la sección entera quedaría invisible ("en blanco").
  ------------------------------------------------------------------ */
  var revealObserver = null;

  /* Al terminar la animación de aparición se retiran las clases .reveal / .is-visible
     y el --reveal-delay. Motivo: html.js .reveal.is-visible { transform: none } pisa
     por especificidad los :hover con transform (p. ej. .card:hover translateY(-4px))
     y el transition-delay del stagger ralentiza el hover → la tarjeta parecía
     "sin animación". Una vez limpia, el hover funciona a plena velocidad. */
  function revealCleanup(el) {
    el.classList.remove('reveal', 'is-visible');
    el.style.removeProperty('--reveal-delay');
  }

  function revealAuto(scope) {
    /* Modo tienda: auto-reveal de cabeceras, FAQs y reseñas con stagger */
    $$('.section-head:not(.reveal), .accordion__item, .review-card', scope).forEach(function (el) {
      el.classList.add('reveal');
      var parent = el.parentElement;
      var sibs = parent ? Array.prototype.indexOf.call(parent.children, el) : 0;
      var extra = (sibs % 6) * 60;
      el.style.setProperty('--reveal-delay', extra + 'ms');
    });
  }

  function revealScan(scope) {
    if (!revealObserver) return;
    $$('.reveal:not(.is-visible)', scope).forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  function initReveal() {
    revealAuto(document);
    if (document.body.getAttribute('data-animations') === 'false') return;
    if (!('IntersectionObserver' in window)) {
      $$('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          el.classList.add('is-visible');
          revealObserver.unobserve(el);
          /* Limpieza al terminar la transición (por propiedad, burbujea: filtrar target) */
          var onEnd = function (ev) {
            if (ev.target !== el) return;
            el.removeEventListener('transitionend', onEnd);
            revealCleanup(el);
          };
          el.addEventListener('transitionend', onEnd);
          /* Red de seguridad: si no hubo transición (animaciones desactivadas,
             pestaña en segundo plano…), limpiar igualmente pasado el tiempo máximo
             de delay (440ms) + transición (1s) + margen. */
          setTimeout(function () { revealCleanup(el); }, 2600);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );
    revealScan(document);

    /* Observar elementos revelados dinámicamente (p. ej. tras refrescar secciones) */
    document.addEventListener('revendex:reveal:rescan', function () {
      revealScan(document);
    });
  }

  /* ------------------------------------------------------------------
     Productos y márgenes — carrusel de descubrimiento (Task 23)
     Scroll horizontal nativo: swipe en móvil y trackpad en escritorio,
     más arrastre con ratón y flechas. La activación (gris → color) se
     calcula con la distancia de cada tarjeta al centro del track y se
     escribe en la variable CSS --act de cada tarjeta.
  ------------------------------------------------------------------ */
  function initDiscovery(scope) {
    $$('[data-discovery]', scope).forEach(function (section) {
      /* Sin guard, re-renderizar la sección en el editor duplicaría listeners */
      if (section.dataset.bound === '1') return;
      section.dataset.bound = '1';
      var track = section.querySelector('[data-discovery-track]');
      if (!track) return;
      var prev = section.querySelector('[data-discovery-prev]');
      var next = section.querySelector('[data-discovery-next]');
      var cards = $$('.discovery-card', track);

      /* Activación 0..1 por tarjeta: 1 en la meseta central, cae con
         smoothstep hasta 0 en los bordes. Ejecutado dentro de rAF. */
      function update() {
        var rect = track.getBoundingClientRect();
        var center = rect.left + rect.width / 2;
        var reach = Math.max(1, rect.width * 0.46);
        cards.forEach(function (card) {
          var r = card.getBoundingClientRect();
          var d = Math.abs(r.left + r.width / 2 - center) / reach;
          var a = (0.92 - d) / 0.72;
          a = Math.max(0, Math.min(1, a));
          a = a * a * (3 - 2 * a);
          card.style.setProperty('--act', a.toFixed(3));
        });
      }
      var raf = null;
      function schedule() {
        if (raf) return;
        raf = window.requestAnimationFrame(function () { raf = null; update(); });
      }
      track.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
      update();

      /* Flechas: avanzan una tarjeta */
      function step() {
        var card = track.querySelector('.discovery-card');
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 16;
        return card ? card.getBoundingClientRect().width + gap : 300;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      /* Arrastre con ratón (el táctil usa el scroll nativo del navegador) */
      var dragging = false;
      var moved = false;
      var startX = 0;
      var startScroll = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        dragging = true;
        moved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        e.preventDefault();
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 5) moved = true;
        track.scrollLeft = startScroll - dx;
      });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);
      /* Tras un arrastre real, el clic no debe navegar al producto */
      track.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);
      /* El arrastre nativo de imágenes/enlaces rompería el drag */
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* ------------------------------------------------------------------
     Carruseles (reseñas)
  ------------------------------------------------------------------ */
  function initCarousels(scope) {
    function updateNav(track, prev, next) {
      if (!track || !prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    $$('[data-carousel]', scope).forEach(function (carousel) {
      /* Sin guard, re-renderizar la sección en el editor duplicaría listeners */
      if (carousel.dataset.bound === '1') return;
      carousel.dataset.bound = '1';
      var track = carousel.querySelector('[data-carousel-track]');
      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      if (!track || !prev || !next) return;
      prev.addEventListener('click', function () {
        var card = track.querySelector('.review-card');
        var step = card ? card.getBoundingClientRect().width + 18 : 340;
        track.scrollBy({ left: -step, behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        var card = track.querySelector('.review-card');
        var step = card ? card.getBoundingClientRect().width + 18 : 340;
        track.scrollBy({ left: step, behavior: 'smooth' });
      });
      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () { updateNav(track, prev, next); });
      }, { passive: true });
      window.addEventListener('resize', function () { updateNav(track, prev, next); });
      updateNav(track, prev, next);
    });
  }

  /* ------------------------------------------------------------------
     Selector de idioma (localización nativa)
  ------------------------------------------------------------------ */
  function initLocalization() {
    document.addEventListener('change', function (e) {
      var select = e.target.closest('select[data-language-select]');
      if (!select) return;
      var form = select.closest('form');
      if (form) form.submit();
    });
  }

  /* ------------------------------------------------------------------
     Galería de producto (miniaturas)
  ------------------------------------------------------------------ */
  function initGallery() {
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      e.preventDefault();
      var gallery = thumb.closest('[data-gallery]');
      if (!gallery) return;
      var mainImg = gallery.querySelector('[data-gallery-main] img');
      var newSrc = thumb.getAttribute('data-gallery-src');
      if (mainImg && newSrc) {
        mainImg.removeAttribute('srcset');
        mainImg.src = newSrc;
      }
      $$('[data-gallery-thumb]', gallery).forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    });
  }

  /* ------------------------------------------------------------------
     Selector de variantes (Task 24)
     Cada opción de Shopify en su propio grupo; "Color" con imágenes.
     La combinación seleccionada resuelve el variant ID exacto que se
     envía al carrito; la imagen principal y el precio siguen a la
     variante. Delegación global: sobrevive a re-renderizados.
  ------------------------------------------------------------------ */
  function getVariantData(picker) {
    var el = picker.querySelector('[data-variants-json]');
    if (!el) return [];
    if (!el._parsed) {
      try { el._parsed = JSON.parse(el.textContent); }
      catch (err) { el._parsed = []; }
    }
    return el._parsed;
  }

  function variantSelection(picker) {
    return $$('.variant-opt', picker).map(function (group) {
      var sel = group.querySelector('[data-option-value].is-selected');
      return sel ? sel.getAttribute('data-option-value') : null;
    });
  }

  function findVariant(variants, options) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < options.length; j++) {
        if (options[j] === null || v.options[j] !== options[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function markVariantAvailability(picker) {
    var variants = getVariantData(picker);
    if (!variants.length) return;
    $$('.variant-opt', picker).forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      $$('[data-option-value]', group).forEach(function (btn) {
        var val = btn.getAttribute('data-option-value');
        var hasAvail = variants.some(function (v) {
          return v.options[idx] === val && v.available;
        });
        btn.classList.toggle('is-unavailable', !hasAvail);
      });
    });
  }

  function applyVariantToGallery(variant) {
    var gallery = $('[data-gallery]');
    if (!gallery) return;
    var mainImg = gallery.querySelector('[data-gallery-main] img');
    if (variant.imageId) {
      /* La miniatura correspondiente reutiliza el mismo flujo que un clic */
      var thumb = gallery.querySelector('[data-gallery-thumb][data-image-id="' + variant.imageId + '"]');
      if (thumb) { thumb.click(); return; }
    }
    if (variant.image && mainImg) {
      mainImg.removeAttribute('srcset');
      mainImg.src = variant.image;
      if (variant.imageAlt) mainImg.alt = variant.imageAlt;
    } else {
      /* Variante sin imagen → imagen principal del producto */
      var firstThumb = gallery.querySelector('[data-gallery-thumb]');
      if (firstThumb) firstThumb.click();
    }
  }

  function applyVariant(picker, variant) {
    /* 1) Selección visual de cada grupo + valor elegido en la cabecera */
    $$('.variant-opt', picker).forEach(function (group) {
      var j = parseInt(group.getAttribute('data-option-index'), 10);
      var val = variant.options[j];
      $$('[data-option-value]', group).forEach(function (b) {
        var isSel = b.getAttribute('data-option-value') === val;
        b.classList.toggle('is-selected', isSel);
        b.setAttribute('aria-pressed', isSel ? 'true' : 'false');
      });
      var label = group.querySelector('[data-option-selected]');
      if (label) label.textContent = val;
    });

    /* 2) Variant ID exacto que viaja al carrito */
    var input = picker.querySelector('[data-variant-input]');
    if (input) {
      input.value = variant.id;
      input.removeAttribute('disabled');
    }

    /* 3) Precio de la variante */
    var priceRoot = $('[data-price-root]');
    if (priceRoot) {
      var html = '';
      if (variant.compareAtPrice) html += '<span class="price__compare">' + variant.compareAtPrice + '</span>';
      html += '<span class="price__now">' + variant.price + '</span>';
      priceRoot.innerHTML = '<span class="price">' + html + '</span>';
    }

    /* 4) Imagen principal de la variante */
    applyVariantToGallery(variant);

    /* 5) Botón de compra */
    var form = picker.closest('form');
    var btn = form && form.querySelector('[data-add-button]');
    if (btn) {
      var labelEl = btn.querySelector('[data-add-label]');
      btn.disabled = !variant.available;
      if (labelEl) {
        labelEl.textContent = variant.available
          ? (btn.getAttribute('data-label-add') || labelEl.textContent)
          : (btn.getAttribute('data-label-sold') || labelEl.textContent);
      }
    }

    /* 6) Estados de disponibilidad de los valores */
    markVariantAvailability(picker);

    /* 7) URL con la variante seleccionada (patrón Shopify) */
    try {
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    } catch (err) { /* la URL nunca debe romper la selección */ }

    document.dispatchEvent(new CustomEvent('revendex:variant:change', {
      detail: { id: variant.id, variant: variant }
    }));
  }

  function initVariants() {
    /* Clic en cualquier valor de opción (delegado) */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-variant-picker] [data-option-value]');
      if (!btn) return;
      var picker = btn.closest('[data-variant-picker]');
      var variants = getVariantData(picker);
      if (!variants.length) return;

      var group = btn.closest('.variant-opt');
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      var value = btn.getAttribute('data-option-value');
      var selection = variantSelection(picker);
      selection[idx] = value;

      /* Combinación exacta; si no existe, salto a la mejor variante que
         contenga el valor pulsado: disponible primero y, entre iguales,
         la que MÁS conserve de la selección previa (Color, Talla…). */
      var target = findVariant(variants, selection);
      if (!target) {
        var clicked = variants.filter(function (v) { return v.options[idx] === value; });
        var avail = clicked.filter(function (v) { return v.available; });
        var pool = avail.length ? avail : clicked;
        var bestScore = -1;
        pool.forEach(function (v) {
          var score = 0;
          for (var k = 0; k < selection.length; k++) {
            if (k !== idx && v.options[k] === selection[k]) score++;
          }
          if (score > bestScore) { bestScore = score; target = v; }
        });
      }
      if (target) applyVariant(picker, target);
    });

    /* Estado inicial: activar el input oculto y marcar disponibilidad */
    $$('[data-variant-picker]').forEach(function (picker) {
      var input = picker.querySelector('[data-variant-input]');
      if (input) input.removeAttribute('disabled');
      markVariantAvailability(picker);
    });
  }

  /* ------------------------------------------------------------------
     Arranque — cada módulo se inicializa de forma aislada: si uno
     falla, el resto de la tienda sigue funcionando.
  ------------------------------------------------------------------ */
  var modules = [
    initHeaderState,
    initPanels,
    initPredictiveSearch,
    initCart,
    initAccordions,
    initReveal,
    initCarousels,
    initDiscovery,
    initLocalization,
    initGallery,
    initVariants
  ];

  function init() {
    modules.forEach(function (mod) {
      try {
        mod();
      } catch (err) {
        // Un módulo roto no debe tumbar el resto de la tienda.
        if (window.console && console.error) console.error('REVENDEX module error:', err);
      }
    });

    /* ---------------------------------------------------------------
       Editor de temas de Shopify.
       Al editar cualquier ajuste (o al añadir/mover/duplicar una sección)
       el editor re-renderiza esa sección: los nodos nuevos llegan SIN
       listeners y SIN la observación reveal, por lo que la sección
       aparecería vacía ("en blanco") — p. ej. el hero al tocar un texto.
       Se re-vincula solo lo afectado, dentro del scope de la sección.
       En la tienda real este evento nunca se dispara: coste cero.
    --------------------------------------------------------------- */
    document.addEventListener('shopify:section:load', function (e) {
      var scope = (e && e.target) || document;
      [
        function () { initHeaderState(); },                     /* header re-renderizado */
        function () { revealAuto(scope); revealScan(scope); },   /* hero, FAQ, reseñas… */
        function () { initCarousels(scope); },                   /* carrusel de reseñas */
        function () { initDiscovery(scope); },                   /* productos y márgenes */
        function () {                                          /* selector de variantes */
          $$('[data-variant-picker]', scope).forEach(function (picker) {
            var input = picker.querySelector('[data-variant-input]');
            if (input) input.removeAttribute('disabled');
            markVariantAvailability(picker);
          });
        }
      ].forEach(function (fn) {
        try {
          fn();
        } catch (err) {
          if (window.console && console.error) console.error('REVENDEX editor rebind error:', err);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

